import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './LinkButton.scss';

const LinkButton = ({
  content,
  onClick,
  className,
  ...rest
}) => (
  <button type='button' onClick={onClick} className={classNames('link-button', className)} {...rest}>
    {content}
  </button>
);

LinkButton.propTypes = {
  className: PropTypes.string,
  content: PropTypes.node,
  onClick: PropTypes.func
};

LinkButton.defaultProps = {
  className: '',
  content: '',
  onClick: () => false
};

export default LinkButton;
